import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  from,
  InMemoryCache,
} from '@apollo/client';
import { onError } from '@apollo/client/link/error';

import { fetch } from 'cross-fetch';

import possibleTypes from '@/config/possibleTypes.json';
import { APP_NAME, NETWORK_STATUS } from '@/utils/constants';

import { GraphQLTokenService } from './graphqlTokenService';
import { UnauthorizedError } from './unauthorizedError';

const isDevelopment = process.env.NODE_ENV === 'development';

const signalError = (e: unknown) => {
  throw e;
};

const gqlTokenService = new GraphQLTokenService(signalError);

const throwAuthErrorIfNeeded = (response: Response) => {
  if (response.status === NETWORK_STATUS.UNAUTHORIZED) {
    throw new UnauthorizedError();
  }
};

// TODO (SELL-519): `internalApiLink` should be removed in the future
// when private graph access is available for first-party apps in the unified API.
const internalApiLink = createHttpLink({
  uri: '/api/graphql',
  headers: {
    'X-Client-ID': APP_NAME,
  },
  fetch,
});
const unifiedApiLink = createHttpLink({
  uri: '/private/graphql',
  fetch: (uri, options) => {
    return gqlTokenService.provideRetry(async () => {
      // Attempt to make a graph request
      const response = await fetch(uri, options);
      // If the response is a graph UNAUTHORIZED error
      // provideRetry will attempt to refresh the token and retry the fetch
      throwAuthErrorIfNeeded(response);
      return response;
    });
  },
});

const requestLink = ApolloLink.split(
  (operation) => operation.getContext().clientName === 'public',
  unifiedApiLink,
  internalApiLink
);

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

export const apolloClient = new ApolloClient({
  ssrMode: true,
  link: from([errorLink, requestLink]),
  cache: new InMemoryCache({
    possibleTypes,
  }),
  name: APP_NAME,
  connectToDevTools: isDevelopment,
});
